/* eslint-disable camelcase */
import Store from "nexia_mobile/flux_like/store";
import Session from "nexia_mobile/models/session";
import MediaType from "nexia_mobile/framework/media_type";
import LocationFixture from "nexia_mobile/models/fixtures/location";

$.mockjaxSettings.responseTime = 500;
$.mockjaxSettings.contentType = "application/json";
$.mockjaxSettings.logging = false;
$.mockjaxSettings.retainAjaxCalls = false;

export default class DemoSession extends Session {
  initialize() {
    this.setUrl("mobile/session");
    this._stubAllEndpoints();
  }

  destroy() {
    this._unstubAllEndpoints();
  }

  _unstubAllEndpoints() {
    this._handlerIds.forEach((id) => $.mockjax.clear(id));
    this._handlerIds = [];
  }

  _stubAllEndpoints() {
    this._handlerIds = [];

    const stub = (obj) => {
      this._handlerIds.push($.mockjax(obj));
    };

    function apiResponse(data) {
      return JSON.stringify({
        success: true,
        error: null,
        result: data,
      });
    }

    const location = _.extend({}, LocationFixture);
    location._links.self = { href: "mobile/houses/1" };

    const session = {
      can_control_automations: true,
      can_manage_locks: true,
      can_view_videos: true,
      can_receive_notifications: true,
      _links: {
        child: [
          {
            href: "mobile/houses/1",
            type: MediaType.LOCATION,
            data: { id: location.id, name: location.name },
          },
        ],
      },
    };

    stub({
      url: /session/,
      responseText: apiResponse(session),
    });

    stub({
      url: /houses\/1/,
      responseText: apiResponse(location),
    });

    stub({
      url: /mode.*activate/,
      type: "POST",
      responseText: apiResponse({}),
    });

    stub({
      url: /automations/,
      responseText: apiResponse(location._urlMap.automations),
    });

    stub({
      url: /events/,
      response(request) {
        let filter = "_NO_FILTER_";
        const matches = request.url.match(/events\??([\w=]+)$/);
        if (matches && matches[1]) {
          filter = matches[1];
        }

        const events = Store.demoModeEvents[filter];

        this.responseText = apiResponse({
          item_type: MediaType.EVENT,
          items: events,
          _links: {
            self: {
              href: request.url,
            },
            page: {
              data: {
                current_page: 1,
                page_count: 1,
              },
            },
          },
        });
      },
    });

    stub({
      url: /videos/,
      responseText: apiResponse(location._urlMap.videos),
    });

    Object.keys(location._urlMap).forEach((url) => {
      stub({
        url,
        type: "GET",
        response(request) {
          const resource = location._urlMap[request.url];
          this.responseText = apiResponse(resource);
        },
      });
    });

    stub({
      type: "DELETE",
      url: /automation/,
      responseText: apiResponse({}),
    });

    stub({
      url: /.*/,
      type: "PUT",
      response(request) {
        const resource = location._urlMap[request.url];
        if (typeof request.data !== "string") {
          request.data = JSON.stringify(request.data);
        }
        const data = _.extend(resource, JSON.parse(request.data || "{}"));
        this.responseText = apiResponse(data);
      },
    });

    stub({
      url: /thermostat.*\/(mode)/,
      urlParams: ["setting"],
      type: "POST",
      response(request) {
        const { setting } = request.urlParams;
        const resource =
          location._urlMap[
            request.url.replace(new RegExp(`/${setting}/?$`), "")
          ];
        const value = request.data.value;
        resource.settings[0].current_value = request.data.value;
        switch (value) {
          case 0: {
            resource.features[0].setpoint_heat = undefined;
            resource.features[0].setpoint_cool = undefined;
            break;
          }
          case 1: {
            resource.features[0].setpoint_heat = resource.setpoints.heat;
            resource.features[0].setpoint_cool = undefined;
            break;
          }
          case 2: {
            resource.features[0].setpoint_heat = undefined;
            resource.features[0].setpoint_cool = resource.setpoints.cool;
            break;
          }
          case 3: {
            resource.features[0].setpoint_heat = resource.setpoints.heat;
            resource.features[0].setpoint_cool = resource.setpoints.cool;
          }
        }
        this.responseText = apiResponse(resource);
      },
    });

    stub({
      url: /thermostat.*\/(setpoints)/,
      urlParams: ["action"],
      type: "POST",
      response(request) {
        const { action } = request.urlParams;
        const resource =
          location._urlMap[request.url.replace(new RegExp(`/${action}$`), "")];

        if (action === "setpoints") {
          resource.setpoints = JSON.parse(request.data);
        }

        this.responseText = apiResponse(resource);
      },
    });

    stub({
      url: /lock.*\/(lock|unlock|activate)$/,
      urlParams: ["action"],
      type: "POST",
      response(request) {
        const { action } = request.urlParams;
        const resource =
          location._urlMap[request.url.replace(new RegExp(`/${action}$`), "")];
        if (action === "lock") {
          resource.current_state = "locked";
          resource.current_action = "unlock";
          resource.icon = { name: "lock_locked", modifiers: [] };
        } else if (action === "unlock") {
          resource.current_state = "unlocked";
          resource.current_action = "lock";
          resource.icon = { name: "lock_unlocked", modifiers: ["insecure"] };
        }

        this.responseText = apiResponse(resource);
      },
    });

    stub({
      url: /switch.*\/(on|off)$/,
      urlParams: ["action"],
      type: "POST",
      response(request) {
        const { action } = request.urlParams;
        const resource =
          location._urlMap[request.url.replace(`/${action}`, "")];
        if (action === "off") {
          resource.value = 0;
          resource.icon = { name: "switch_off" };
        } else {
          resource.value = 255;
          resource.icon = { name: "switch_on" };
        }

        this.responseText = apiResponse(resource);
      },
    });

    stub({
      url: /.*/,
      type: "POST",
      response(request) {
        if (typeof request.data !== "string") {
          request.data = JSON.stringify(request.data);
        }
        this.responseText = apiResponse(JSON.parse(request.data || "{}"));
      },
    });
  }

  _loadFromCache() {
    // no-op parent behavior
  }

  _addToSessionCache() {
    // no-op parent behavior
  }

  _defaultLocationId() {
    return 1;
  }
}



// WEBPACK FOOTER //
// ./src/models/demo_session.js